import styled from 'styled-components';
import { FlexBox, Stack } from '@ardoq/layout';
import { SHOW_ONLY_CONNECTED_COMPONENTS } from '@ardoq/global-consts';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { type I18nLocale, t } from '@ardoq/i18n';

/** these error messages are normally displayed in italics, but this one gets normal font-style with a certain phrase in italics ¯\\\_(ツ)\_/¯ */
const NoItalics = styled.div`
  font-style: normal;
`;

type NotConnectedErrorProperties = {
  message: string;
  i18nLocale: I18nLocale;
};
export const NotConnectedError = ({
  message,
  i18nLocale,
}: NotConnectedErrorProperties) => (
  <NoItalics>
    <Stack gap="xlarge">
      <FlexBox gap="medium">{message}</FlexBox>
      <FlexBox gap="medium">
        <span style={{ display: 'inline' }}>
          {t(
            i18nLocale,
            'graph:notConnectedError.deactivateModifierHint',
            { modifierName: SHOW_ONLY_CONNECTED_COMPONENTS },
            'To show more data, deactivate the view modifier "{{modifierName}}"'
          )}{' '}
          <Icon iconSize={IconSize.SMALL} iconName={IconName.LINK} />
        </span>
      </FlexBox>
    </Stack>
  </NoItalics>
);
